import React, {useState} from 'react'
import RegionCreada from '../img/Region1.png'
import RegionFonchi from '../img/RegionFonchi.png'

const FonchiMap = ({serviciosCentro, capitalize, serviceIcons, handleServiceClick}) => {
  const [hoveredService, setHoveredService] = useState(false);

  const rawSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6">
      <defs>
        <pattern id="hatchPattern" width="6" height="6" patternUnits="userSpaceOnUse">
          <!-- línea diagonal de esquina a esquina -->
          <line x1="0" y1="6" x2="6" y2="0"
                stroke="#000" stroke-width="1"/>
        </pattern>
      </defs>
      <rect width="6" height="6" fill="url(#hatchPattern)"/>
    </svg>
  `;
  const hatchSvg = encodeURIComponent(rawSvg);

  return (
    <div
      className="fonchi-placeholder"
      style={{ width: '100%', height: '45vh',backgroundImage: `url("data:image/svg+xml;utf8,${hatchSvg}")`, backgroundRepeat: 'repeat',position: 'absolute',  }}
      onClick={e => { e.stopPropagation(); setHoveredService(!hoveredService); }}
    >
      <svg width=".5vw" height="2vh" viewBox="0 0 24 24" className="loader-location-svg"
        style={{ position: 'absolute', top: '42%', left: '58%', transform: 'translate(-50%, -50%) scale(1.1)', zIndex: 2,
        }}
      >
        <ellipse cx={12} cy={12} rx={12} ry={12} fill="rgba(0, 0, 0, 0.2)" className="loader-location-shadow"/>
        <path
          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
          fill="#e94e1a" stroke="#e94e1a" strokeWidth="10" className="loader-location-chile"
        />
      </svg>

      <img
        className="overlay-image"
        src={RegionFonchi}
        alt="Fonchi Overlay"
      />

      {/* {hoveredService && (() => {
        const fonchiKey = Object.keys(serviciosCentro)
          .find(k => k.toLowerCase().includes('fonchi'));
        if (!fonchiKey) return null;

        const centers = serviciosCentro[fonchiKey];
        const baseRadius = 55; 

        return (
                    
          <div>
            {Object.entries(centers).map(([centerKey, services]) => {
              const displayName = capitalize(centerKey.split('-')[0]);

              const activeServices = Object.entries(services)
                .filter(([_, info]) => info.status_service);

              const count = activeServices.length;
              if (count === 0) return null;

              return (
                <div
                  key={centerKey}
                  style={{
                    position: 'absoluta',
                    width: baseRadius * 2,
                    height: baseRadius * 2,
                    marginLeft:'25.8vw !important',
                    marginTop:'5vh',
                  }}
                >
                  <p
                    style={{
                      position: 'absolute',
                      color:'#c3c3c3',
                      fontSize:'0.5vw',
                      top: '55%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)'
                    }}
                  >
                    {displayName}
                  </p>

                  {activeServices.map(([svcName, info], idx) => {
                    const angle = (2 * Math.PI / count) * idx - Math.PI / 2;
                    const dx = Math.cos(angle) * baseRadius;
                    const dy = Math.sin(angle) * baseRadius;

                    return (
                      <img
                        key={svcName}
                        src={serviceIcons[svcName]}
                        onClick={e => {
                          e.stopPropagation();
                          handleServiceClick(svcName,info);
                        }}

                        alt={svcName}
                        className={`service-img status-${info.status.toLowerCase()}${info.status_service ? '' : ' inactive'}`}
                        style={{
                          height:'8%',
                          width:'8%',
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: `translate(${dx}px, ${dy}px) translate(-50%, -50%)`,
                        }}
                      />
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })()} */}

    </div>
  )
}

export default FonchiMap